export function onVisibleCallback(options = {}) {
    const defaults = {
        element:        null,
        root:           null,
        visiblePercent: .3,
        callback:       () => {
        },
        once:           false,
    }

    options = { ...defaults, ...options }

    const observer = new IntersectionObserver((entries, opts) => {
        entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        options.callback()
                        options.once && observer.disconnect()
                    }
                },
        )
    }, {
        root:      null,
        threshold: options.visiblePercent,
    })

    options.element && observer.observe(options.element)
}

export class TruncatePostP {
    constructor(el) {
        this.line_height = 22
        this.$el         = el
        this.$el.classList.add('truncated')
        this.timeout = null

        this.doTrunc()

        window.addEventListener('resize', () => {
            this.timeout && clearTimeout(this.timeout)
            this.timeout = setTimeout(this.doTrunc.bind(this), 100)
        })
    }

    doTrunc() {
        this.$el.style.height = null

        let lines = Math.floor(this.$el.clientHeight / this.line_height)

        this.$el.style.height                = (lines * this.line_height) + 'px'
        this.$el.style['-webkit-line-clamp'] = lines
    }
}

export async function ajax(action = '', data = {}){
    const form_data = new FormData()
    form_data.append('action', action)
    form_data.append('form', JSON.stringify(data))

    let response = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body:   form_data,
    });

    let json = await response.json();
    json.status = response.status;

    return json;
}
